import { Component, signal, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { RouterOutlet, RouterModule } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { DataService } from '../../services/data.service';
import { AlertConfirmService } from '../../services/alert-confirm.service';

import { CONTENT_COMPONENTS, MAIN_COMPONENTS, MAP_COMPONENTS } from '../components-list1';
import { MainComponent } from '../main/main.component';
// import { ChatWidget } from '../../common/widgets/chat-widget/chat-widget';
import { LedgerCalculatorComponent } from '../../common/ledger-calculator/ledger-calculator.component';

interface NavItem {
  icon: string;
  label: string;
  route: string;
  badge?: string | number;
  badgeClass?: string;
  children?: { label: string; route: string }[];
  visible: boolean;
  optFor: string;
}

export type NotifCategory =
  | 'admission'
  | 'fee'
  | 'attendance'
  | 'exam'
  | 'staff'
  | 'transport'
  | 'announcement'
  | 'system'
  | 'leave'
  | 'timetable';

interface Notification {
  id:         number;
  icon:       string;
  icon_bg:    string;
  ntext:      string;
  ntime:      string;
  unread:    boolean;
  category?: NotifCategory;
  ndetail?:   string;
  ntimestamp?:string;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    RouterOutlet, RouterModule, RouterLink, RouterLinkActive, CommonModule, MainComponent, 
    LedgerCalculatorComponent, CONTENT_COMPONENTS, MAIN_COMPONENTS, 
    // ChatWidget
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  dataService = inject(DataService);
  sidebarCollapsed = signal(false);
  mobileSidebarOpen = signal(false);
  notificationsOpen = signal(false);
  profileOpen = signal(false);
  currentTime = signal(new Date());
  reNewAlert: boolean = false;

  acd_session = '';
  user: any = {};
  pg: any = '';
  loading = false;

  // Getter to find the current component type
  get currentComponent() {
    return MAP_COMPONENTS[this.pg] || null;
  }

  // Used to highlight the left panel menu items
  readonly navItems: NavItem[] = [
    { icon: 'bi-speedometer2',      label: 'Dashboard',         route: '/dashboard/home',   visible: true, optFor: 'BO' },
    { icon: 'bi-person-plus-fill',  label: 'Masters',           route: '/subpg/masters',    visible: true, optFor: 'BO' },
    { icon: 'bi-search-heart-fill', label: 'Eligibility Check', route: '/dashboard/301509', visible: true, optFor: 'UR' },
    // { icon: 'bi-megaphone-fill',    label: 'Communications',    route: '/subpg/communications', visible: true, optFor: 'BO' },
    { icon: 'bi-megaphone-fill',    label: 'Contact Messages',  route: '/dashboard/30141d02', visible: true, optFor: 'SA' },

    { icon: 'bi-calendar3',         label: 'Time-Table',        route: '/dashboard/270d02', visible: this.getPermission('ttl'), optFor: 'UR' },
    { icon: 'bi-calendar3',         label: 'Attendance',        route: '/dashboard/320d1a', visible: this.getPermission('att'), optFor: 'UR' },
    { icon: 'bi-cash-coin',         label: 'Fee Management',    route: '/dashboard/351c0b', visible: this.getPermission('fee'), optFor: 'UR' },
    { icon: 'bi-trophy-fill',       label: 'Examinations',      route: '/dashboard/2b1803', visible: this.getPermission('xam'), optFor: 'UR' },
    { icon: 'bi-bus-front-fill',    label: 'Transport',         route: '/dashboard/270b1e', visible: this.getPermission('trp'), optFor: 'UR' },
    { icon: 'bi-house-fill',        label: 'Gate Pass',         route: '/dashboard/201e1e', visible: this.getPermission('sgp'), optFor: 'UR' },
    { icon: 'bi-book-fill',         label: 'Library',           route: '/dashboard/3f100c', visible: this.getPermission('lib'), optFor: 'UR' },
    { icon: 'bi-book-fill',         label: 'Inventory Mgmt.',   route: '/dashboard/3a1718', visible: this.getPermission('inv'), optFor: 'UR' },
    { icon: 'bi-house-fill',        label: 'Home Work',         route: '/dashboard/201119', visible: this.getPermission('shw'), optFor: 'UR' },
    { icon: 'bi-cash-coin',         label: 'HR Admin',          route: '/dashboard/3b0b0f', visible: this.getPermission('hra'), optFor: 'UR' }
  ];

  // readonly notifications: any = [
  notifications = signal<Notification[]>([
    // { icon: 'bi-person-plus', iconBg: 'bg-primary', text: 'New admission application received', time: '5 min ago', unread: true },
    // { icon: 'bi-cash', iconBg: 'bg-warning', text: '8 fee payments pending approval', time: '1 hour ago', unread: true },
    // { icon: 'bi-exclamation-triangle', iconBg: 'bg-danger', text: 'Attendance below 75% – 12 students', time: '3 hours ago', unread: true },
    // { icon: 'bi-calendar-check', iconBg: 'bg-success', text: 'Exam schedule published for Class X', time: '1 day ago', unread: false },
    // { icon: 'bi-megaphone', iconBg: 'bg-info', text: 'Annual day celebration on July 15', time: '2 days ago', unread: false },
  ]);

  subPage = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService, 
    public alertService: AlertConfirmService, 
    // private modalService: ModalService
    private cdr: ChangeDetectorRef
  ) {
    // if(this.currentTime()) {
    //   setInterval(() => this.currentTime.set(new Date()), 1000);
    // }
  }

  async ngOnInit() {
    // alert(this.dataService.myEncrypt('prom'));
    if(!this.dataService.ddData) {
      await this.dataService.getDDData();
    }

    let segments: any = this.route.snapshot.url[0].path;
    if(segments && segments != 'dashboard') {
      this.subPage = true;
    }
    // this.acd_session = this.dataService.settings.active_session.acd_year;

    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
      this.acd_session = this.user.session + '-' + ((parseInt(this.user.session) + 1) - 2000);

      const curDate: Date = new Date();
      const expDate: Date = new Date(this.user.exp_date);
      const dayRemains = this.dataService.getDaysDiff(curDate, expDate);

      if(dayRemains < 15) {
        this.reNewAlert = true;
      } else {
        this.reNewAlert = false;
      }
    }

		// this.loading = true;
    // await this.dataService.getAllRecords('notifications').then((res: any) => {
    //   if(res && res.length) {
    //     this.notifications.set(res);
    //   }
    //   this.loading = false;
    // });

    if(this.user.user_role[0].code == 'adm' && this.user.user_name != 'mwcc') {
      await this.dataService.getSingleRecord('my_package', this.user.erp_key).then((res: any) => {
        this.dataService.my_modules = res || [];
        sessionStorage.setItem('my_modules', JSON.stringify(res));
      });
    }

    const curDate: Date = new Date();
    const expDate: Date = new Date(erp_rem?.exp_date?.substr(0, 10));
    const dayRemains = this.dataService.getDaysDiff(curDate, expDate);
    const myRoleCode: string = erp_rem?.user_role && erp_rem?.user_role[0].code;

    this.route.paramMap.subscribe((params: any) => {
      const pgCode = params.get('pg');
      // console.log(pgCode);
      this.pg = this.dataService.myDecrypt(pgCode);

      if(myRoleCode=="spr") return;

      if(this.pg) {
        if(this.pg && (this.pg=='trial')) {
          const myBtn: any = document.getElementById('trialModalBtn');
          myBtn.click();
          return;
        } else if(this.pg && (this.pg=='kyc')) {
          const myBtn: any = document.getElementById('kycModalBtn');
          myBtn.click();
          return;
        // } else if(this.pg && (this.pg=='agreement')) {
        //   const myBtn: any = document.getElementById('agmModalBtn');
        //   myBtn.click();
        }
      // } else {
      //   if(erp_rem.for_trial) {
      //     if(dayRemains < 0) {
      //       this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('trial')]);
      //     }
      //   }
      }
    });
  }

  ngAfterContentChecked() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

    let active_role: any = localStorage.getItem("active_role");
    if(active_role && this.user.user_role.length > 1) {
      active_role = JSON.parse(active_role);
      if(!active_role) {
        this.user.code = this.user.user_role[0].code;
        this.user.position = this.user.user_role[0].name;
      } else {
        this.user.code = active_role.code;
        this.user.position = active_role.name || active_role.position;
      }
    } else {
      localStorage.removeItem("active_role");
      this.user.code = this.user.user_role[0].code;
      this.user.position = this.user.user_role[0].name;
    }
  }

  get unreadCount(): number {
    return this.notifications()?.filter((n: any) => n.unread).length;
  }

  toggleSidebar(): void {
    this.sidebarCollapsed.update(v => !v);
  }

  toggleMobileSidebar(): void {
    this.mobileSidebarOpen.update(v => !v);
  }

  closeOverlays(): void {
    this.notificationsOpen.set(false);
    this.profileOpen.set(false);
  }

  toggleNotifications(): void {
    this.notificationsOpen.update(v => !v);
    this.profileOpen.set(false);
  }

  toggleProfile(): void {
    this.profileOpen.update(v => !v);
    this.notificationsOpen.set(false);
  }

  markAllRead(): void {
    this.notifications()?.forEach((n: any) => n.unread = false);
  }

  myProfile() {
    this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('profile')]);
  }

  changeRole(role: any) {
    /*
    const items = this.user.user_role;

    // Find the targeted object
    const targetObject = items.find((item: any) => item.code === role.code);

    // Filter out the object from the remaining list, then combine
    const updatedItems = [
      targetObject,
      ...items.filter((item: any) => item.code !== role.code)
    ];

    this.user.user_role = updatedItems;
    this.user.code = this.user.user_role[0].code;
    this.user.position = this.user.user_role[0].name;
    */
    localStorage.setItem("active_role", JSON.stringify(role));
  }

  getPermission(mm_code: any) {
    let my_modules: any = sessionStorage.getItem('my_modules');
    if(my_modules) {
      my_modules = JSON.parse(my_modules);
    }

    const result: string = my_modules?.find((m: any) => m === mm_code);
    const tfVal: boolean = (result=="" || result==undefined) ? false : true;
    return tfVal;
  }

  logout() { 
    this.alertService.confirm(
      'Logout?',
      'Are you sure you want to exit?',
      () => {
        this.auth.logout();
      },
      () => {
        //alert("No");
      },
      'primary'
    );
  }

  copyText(textToCopy: string) {
    // 1. Get the text content from your target element
    let text: any = document.getElementById(textToCopy);

    if(text) {
      text = text.innerText;
    }
    
    // 2. Use the Clipboard API to copy it
    navigator.clipboard.writeText(text).then(() => {
      alert("Text copied to clipboard!"); // User feedback
    })
    .catch(err => {
      console.error("Failed to copy text: ", err);
    });
  }

  onImported(result: unknown): void {
    console.log('Imported:', result);
  }

  onExported(result: unknown): void {
    console.log('Exported:', result);
  }
}
